import { useState } from "react";
import { PanelShell, Badge, TextField, tokens, DJSEMApiClient, preflightAIGeneration } from "../index";
import type { DJSEMPlatform } from "../platform";
import { VideoGenerationModule } from "./VideoGeneration";
import { CueDirectorModule } from "./CueDirectorModule";

/**
 * Create module — the AI generation screen: a rights-safe preflight check on a text prompt,
 * followed by the AI Video Generation and Cue Director sub-modules.
 *
 * @param client - The API client passed through to the video generation and cue director sub-modules.
 * @param platform - The current platform (web/desktop), passed through to the video generation sub-module.
 * @returns A preflight panel plus the AI Video Generation and Cue Director module panels.
 */
export function CreateModule({ client, platform }: { client: DJSEMApiClient; platform: DJSEMPlatform }) {
  const [prompt, setPrompt] = useState("");
  const preflight = preflightAIGeneration({ engine: "artwork", prompt, requestedForPublicOutput: true });
  return (
    <>
      <PanelShell title="AI generation (rights-safe)">
        <div style={{ fontSize: 12, color: tokens.color.accent, marginBottom: 10, fontStyle: "italic" }}>
          AI suggests. Artist decides. DJSEM explains. You approve.
        </div>
        <TextField value={prompt} onChange={setPrompt} placeholder="Prompt…" style={{ width: "100%" }} />
        <div style={{ marginTop: 8, fontSize: 12 }}>
          {preflight.ok ? <Badge tone="ok">preflight ok</Badge> : <Badge tone="warn">blocked</Badge>}
        </div>
        {preflight.blockers.map((b, i) => <div key={i} style={{ fontSize: 11, color: tokens.color.danger, marginTop: 4 }}>{b}</div>)}
        {preflight.warnings.map((w, i) => <div key={i} style={{ fontSize: 11, color: "#e8b24a", marginTop: 4 }}>{w}</div>)}
      </PanelShell>
      <VideoGenerationModule client={client} platform={platform} />
      <CueDirectorModule client={client} />
    </>
  );
}
